import { render, staticRenderFns } from "./YoutubeCallBack.vue?vue&type=template&id=642c92e4&scoped=true"
import script from "./YoutubeCallBack.vue?vue&type=script&lang=js"
export * from "./YoutubeCallBack.vue?vue&type=script&lang=js"
import style0 from "./YoutubeCallBack.vue?vue&type=style&index=0&id=642c92e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c92e4",
  null
  
)

export default component.exports